module.exports = __webpack_public_path__ + "img/cover.4ad54b60.jpg";